let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4A2F7")).then(() => parcelRequire('85aXb'));